import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  pageSize: number;
  currentPage: number;
  searchText: string;
  isActive: boolean;
}

export type OrganisationSearchResultDTO = {
  id: string;
  shortCode: string;
  name: string;
  codeSet: string;
  logoUrl: string | null;
  isActive: boolean;
};

interface Result {
  records: OrganisationSearchResultDTO[];
  recordCount: number;
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/organisations',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useSearchOrganisations = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useSearchOrganisationLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSearchOrganisations;
